import React, { useState } from 'react'
import Modal from 'components/shared/Modal'
import GenerateChallengeForm from './GenerateChallengeForm'

interface GenerateChallengeModalProps {
	isOpen: boolean
	onModalClose: Function
}

const GenerateChallengeModal = ({
	isOpen,
	onModalClose,
}: GenerateChallengeModalProps) => {
	const [isGenerating, setIsGenerating] = useState<boolean>(false)

	const handleGenerateStatusChange = (status: boolean) => {
		setIsGenerating(status)
	}

	return (
		<Modal
			isOpen={isOpen}
			onModalClose={onModalClose}
			closeEnabled={!isGenerating}
			showFooter={false}
			contentLabel={'Create your challenge description with AI'}
		>
			<GenerateChallengeForm
				onGenerateStatusChange={handleGenerateStatusChange}
			/>
		</Modal>
	)
}

GenerateChallengeModal.displayName = 'GenerateChallengeModal'

export default GenerateChallengeModal
